import { Col, Container } from "react-bootstrap";
import { fadeIn } from "../../../Functions/GlobalAnimations";
import { m } from "framer-motion";
import Buttons from "../../../Components/Button/Buttons";

const About = () => {
  return (
    <>
      <m.section id="about" className="mb-[100px]">
        <Container>
          {/* <Col xs={10} lg={7} className="relative ">
                            <Row className='flex justify-center mb-2' >
                                <Col xs={12} sm={12} lg={12}>
                                    <div className=" flex flex-col w-[100%] items-center">
                                        <img className="w-[200px] h-[200px] rounded-full" alt="" src="/images/pinarayi_vijayan.webp" />
                                        <m.span className="  font-bold text-center text-[20px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. Pinarayi Vijayan
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Chief Minister, Govt. of Kerala
                                        </m.span>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mb-2'>

                                <Col xs={12} sm={12} lg={6}>
                                    <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Prasad.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. P. Prasad
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Minister for Agriculture, Govt. of Kerala
                                            <br />
                                        </m.span>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} lg={6}>
                                    <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/rajeev.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. P. Rajeeve
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Minister for Industries, Govt. of Kerala
                                        </m.span>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mb-2'>
                                    <Col xs={12} sm={12} lg={4}>
                                        <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                            <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Ashok IAS.webp" />
                                            <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                                Dr. B. Ashok IAS
                                            </m.span>
                                            <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                                Agriculture Production Commissioner, Govt. of Kerala
                                                <br />
                                                Project Director
                                            </m.span>
                                        </div>
                                    </Col>
                                <Col xs={12} sm={12} lg={4}>
                                    <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Vigneshwari.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Smt. V. Vigneshwari IAS
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Addl. Secretary Agriculture, Govt. of Kerala
                                            <br />
                                            Additional Project Director
                                        </m.span>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} lg={4}>
                                    <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/vishnuraj.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. Vishnuraj P. IAS
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Director of Industries, Govt. of Kerala
                                            <br />
                                            Additional Project Director
                                        </m.span>
                                    </div>
                                </Col>
                            </Row>

                            <div className="flex flex-col gap-[20px] justify-center items-center">
                                <div className="flex w-[100%] sm:flex-col gap-[20px]">

                                </div>

                            </div>
                        </Col> */}
          <Col
            xs={12}
            xl={{ span: 12 }}
            lg={{ span: 12 }}
            className="md:mt-[15%]  xs:mt-[18%]"
          >
            <m.h2
              className="heading-4 mb-16 font-semibold -tracking-[1px] text-darkgray font-serif"
              {...{ ...fadeIn, transition: { delay: 0.2 } }}
            >
              WELCOME TO KERA
            </m.h2>
            <m.p
              className="mb-2 w-[98%] text-justify text-[17px]"
              {...{ ...fadeIn, transition: { delay: 0.5 } }}
            >
              The Kerala Climate Resilient Agri-Value Chain Modernization (KERA)
              Project is a flagship initiative of the Government of Kerala,
              implemented with the financial and technical support of the World
              Bank. Designed to transform the agricultural landscape of Kerala,
              KERA addresses the mounting challenges posed by climate change,
              fragmented markets, and inefficient value chains, especially
              affecting small and marginal farmers.
            </m.p>
            <m.p
              className="mb-2 w-[98%] text-justify text-[17px]"
              {...{ ...fadeIn, transition: { delay: 0.5 } }}
            >
              Conceptualized in response to the pressing need for inclusive and
              climate-smart agricultural development, KERA focuses on
              strengthening selected value chains through end-to-end
              interventions—from farm-level production to market access. With a
              special emphasis on integrating farmer producer companies (FPCs),
              leveraging digital platforms, and promoting agri-entrepreneurship,
              the project aims to ensure higher incomes, sustainability, and
              resilience for Kerala’s farming communities.
            </m.p>
            <m.p
              className="mb-2 w-[98%] text-justify text-[17px]"
              {...{ ...fadeIn, transition: { delay: 0.5 } }}
            >
              KERA is not just a project - it is a comprehensive transformation
              journey toward a more resilient, inclusive, and prosperous
              agri-value ecosystem for the state.
            </m.p>
            <m.div {...{ ...fadeIn, transition: { delay: 1 } }}>
              <Buttons
                className="font-medium font-serif uppercase hover:text-darkgray btn-expand mt-[56px]"
                size="lg"
                color="#232323"
                themeColor="#2ed47c"
                to="/about_us"
                title="Read more"
              />
            </m.div>
          </Col>
        </Container>
        {/* <Row className='items-center'>
                        <Col xl={3}>
                            <div className=" flex flex-col w-[100%] items-center">
                                <img className="w-[250px] h-[250px] rounded-full" alt="" src="/images/pinarayi_vijayan.webp" />
                                <m.span className="  font-bold text-center text-[20px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                    Shri. Pinarayi Vijayan
                                </m.span>
                                <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                    Chief Minister, Govt. of Kerala
                                </m.span>
                            </div>
                        </Col>
                        <Col xl={9}>
                            <Row>
                                <Col xs={6} sm={12} lg={6}>
                                    <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Prasad.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. P. Prasad
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Minister for Agriculture, Govt. of Kerala
                                            <br />
                                        </m.span>
                                    </div>
                                </Col>
                                <Col xs={6} sm={12} lg={6}>
                                    <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/rajeev.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. P. Rajeeve
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Minister for Industries, Govt. of Kerala
                                        </m.span>
                                    </div>
                                </Col>
                                <Row className='mb-2 flex justify-center'>
                                    <Col xs={12} sm={12} lg={6}>
                                        <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                            <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Ashok IAS.webp" />
                                            <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                                Dr. B. Ashok IAS
                                            </m.span>
                                            <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                                Agriculture Production Commissioner, Govt. of Kerala
                                                <br />
                                                Project Director
                                            </m.span>
                                        </div>
                                    </Col>
                                </Row>
                            </Row>
                            <Row className='mb-2'>
                                <Col xs={12} sm={12} lg={6}>
                                    <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/vishnuraj.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Shri. Vishnuraj P. IAS
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Director of Industries, Govt. of Kerala
                                            <br />
                                            Additional Project Director
                                        </m.span>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} lg={6}>
                                    <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                                        <img className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full" alt="" src="/images/Vigneshwari.webp" />
                                        <m.span className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Smt. V. Vigneshwari IAS
                                        </m.span>
                                        <m.span className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block" {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                                            Addl. Secretary Agriculture, Govt. of Kerala
                                            <br />
                                            Additional Project Director
                                        </m.span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                    </Row>

                    <Col xs={12} xl={{ span: 12 }} lg={{ span: 6, offset: 1 }} className="md:mt-[15%] mt-[50px] xs:mt-[18%]">
                        <m.h2 className="heading-4 mb-16 font-semibold -tracking-[1px] text-darkgray font-serif" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                            WELCOME TO KERA
                        </m.h2>
                        <m.p className="mb-2 w-[98%] text-justify" {...{ ...fadeIn, transition: { delay: 0.5 } }}>
                            The Kerala Climate Resilient Agro-Value Chain Modernization (KERA) Project is a flagship initiative of the Government of Kerala, implemented with the financial and technical support of the World Bank. Designed to transform the agricultural landscape of Kerala, KERA addresses the mounting challenges posed by climate change, fragmented markets, and inefficient value chains, especially affecting small and marginal farmers.
                        </m.p>
                        <m.p className="mb-2 w-[98%] text-justify" {...{ ...fadeIn, transition: { delay: 0.5 } }}>
                            Conceptualized in response to the pressing need for inclusive and climate-smart agricultural development, KERA focuses on strengthening selected value chains through end-to-end interventions—from farm-level production to market access. With a special emphasis on integrating farmer producer organizations (FPOs), leveraging digital platforms, and promoting agri-entrepreneurship, the project aims to ensure higher incomes, sustainability, and resilience for Kerala’s farming communities.
                        </m.p>
                        <m.p className="mb-2 w-[98%] text-justify" {...{ ...fadeIn, transition: { delay: 0.5 } }}>
                            KERA is not just a project - it is a comprehensive transformation journey toward a more resilient, inclusive, and prosperous agri-value ecosystem for the state.
                        </m.p>
                        <m.div {...{ ...fadeIn, transition: { delay: 1 } }}>
                            <Buttons
                                className="font-medium font-serif uppercase hover:text-darkgray btn-expand mt-[56px]"
                                size="lg"
                                color="#232323"
                                themeColor="#2ed47c"
                                to="/about_us"
                                title="Read more"
                            />
                        </m.div>
                    </Col> */}
      </m.section>
    </>
  );
};

export default About;
